export class ServiceConceptType {
  edited: boolean;
  serviceConceptTypeId: number;
  serviceConceptTypeName: string;
  isFixed: boolean;
  isMeal: boolean;
  isFoodService: boolean;
  serviceId: number;
  isActive: boolean;
  order: number;
  invoiceAccountId: number;
}
